export default {
    cropperAspectRatio() {
        let ratio = 1

        if (this.croppingModel === 'cover') {
            ratio = 5.9
        }

        return ratio
    }
}
